import util from '../../utils/util.js'

const state = {
	useName: "sam11",
	testTag: '0', //0-正常模式 1-进入压测模式
	
	isShowLog: util.getLocalPermit('log'), //日志管理
	isShowWord: util.getLocalPermit('word'),  //留言管理
	isColleague: util.getLocalPermit('colleage'),  //我的同事
	isTrouble: util.getLocalPermit('trouble'),  //疑似骚扰用户
	
	isEndChat: util.getLocalPermit('endChat'), //结束会话
	isTransfer: util.getLocalPermit('transter'), //转接
	isDefriend: util.getLocalPermit('defriend'),//黑名单
	isAdapter: util.getLocalPermit('adapter'),//接管
	isDisturb: util.getLocalPermit('disturb'), //勿扰
	isMarkTag: util.getLocalPermit('markTag'), //打标签
	isTransferTa: util.getLocalPermit('transterTa'), //转接给他人
	
	isShowBot: util.getLocalPermit('bot'), //机器人管理
	isShowRecord: util.getLocalPermit('record'), //对话记录
	isOnlineList: util.getLocalPermit('isOnlineList'), //在线访客列表
	isOnlineOffList: util.getLocalPermit('isOnlineOffList'), //已离开（未结束）
	isQuickShow: util.getLocalPermit('quickShow'), //同事快捷展示
	isPublicQuickShow: util.getLocalPermit('publicQuickShow'), //公共快捷展示
	
	isDownHtml: util.getLocalPermit('downHtml'), //对话记录
	
	personList:util.getLocalPermit('personPmtList'), //个人设置列表
	systemList:util.getLocalPermit('systemPmtList'), //系统设置列表
	midmanList:util.getLocalPermit('midmanPmtList'), //middleman管理列表
	loginmg:util.getLocalPermit('loginmgList'), //登录管理
	wsStateTag: '1',//1-登录成功 2-
	
	type3Data: null,
	
	timeLength: JSON.parse(localStorage.getItem("account")) == null ? '' : JSON.parse(localStorage.getItem("account")).timeLength,
	userStatus: (function () {
		const account = JSON.parse(localStorage.getItem("account"))
		if (account == null || account.userStatus === undefined || account.userStatus === null || account.userStatus === '') {
			return 1
		}
		return Number(account.userStatus)
	})()
	
}

const getters = {
	
}

const mutations = {
	change_name (state, anotherName) {
		console.log('authority mutations change_name = ', anotherName)
		state.useName = anotherName
	}
}

const actions = {
	//和没有modules的时候一样，同样的方式dispatch action
	//this.$store.dispatch("changeName", "Jason")
	changeName ({commit}, anotherName) {
		console.log('authority actions changeName = ', anotherName)
		commit("change_name", anotherName)
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}
